import React, { useState, useContext, useEffect } from "react";
import { Card, Button, Divider, Text } from "@mantine/core";
import { withAuthenticator } from "@aws-amplify/ui-react";
import axios from "axios";
import "../App.css";
// import { LinkedContext } from "../Contexts/LinkedContext";
import { SelectedContext } from "../Contexts/SelectedContext";
import { useAuthenticator } from "@aws-amplify/ui-react";
import ProfileData from "./Settings/ProfileData";
import BillingsData from "./Settings/BillingsData";
// import Connections from "./Settings/Connections";

function Settings({ signOut }) {
  const { selected } = useContext(SelectedContext);
  const { user } = useAuthenticator((context) => [context.user]);
  const [currentPage, setCurrentPage] = useState(
    <ProfileData signOut={signOut} user={user} />
  );
  const [active1, setActive1] = useState("filled");
  const [active2, setActive2] = useState("outline");
  const [active3, setActive3] = useState("outline");

  useEffect(() => {
    axios
      .post(
        "https://17eh5s1nff.execute-api.eu-north-1.amazonaws.com/doglass/",
        {},
        {
          headers: {
            Authorization: user.signInUserSession.idToken.jwtToken,
          },
        }
      )
      .then((res) => {
        // console.log(res.data);
      }, []);
  });

  
  return (
    <div style={{ padding: 10, marginTop: 20 }}>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ width: "80rem", height: "6rem" }}>
          <Text size={28} weight={600}>
            Settings
          </Text>
          <Text color="dimmed" size={16}>
            Edit your profile and billings data.
          </Text>
        </div>
      </div>
      <div style={{ display: "flex" }}>
        <Card
          shadow="md"
          radius={5}
          style={{
            width: "90%",
            // height: "52rem",
            marginLeft: "5%",
          }}
        >
          <Button
            variant={active1}
            ml="xl"
            mr="xl"
            mb="sm"
            onClick={() => {
              setCurrentPage(<ProfileData signOut={signOut} user={user} />);
              setActive1("filled");
              setActive2("outline");
              setActive3("outline");
            }}
          >
            Profile Data
          </Button>
          <Button
            variant={active2}
            ml="xl"
            mr="xl"
            mb="sm"
            onClick={() => {
              setCurrentPage(<BillingsData user={user} />);
              setActive1("outline");
              setActive2("filled");
              setActive3("outline");
            }}
          >
            Billings Data
          </Button>
          <Divider mb="xl" />
          <div style={{ minHeight: "35rem" }}>{currentPage}</div>
        </Card>
      </div>
    </div>
  );
}

export default withAuthenticator(Settings);
